import BASE_URL from "../API";
import { io } from "socket.io-client";
import Cookies from "js-cookie";
import { addNewNotification, updateReadNotification } from "./notificationsSlice";
import { triggerEventsRefresh } from "./eventsSlice";

let socketInstance = null; // Socket instance initialized as null

// The server now refuses socket connections without a session (QA finding
// SEC-09). Read the token at each (re)connect rather than once, so a socket
// opened after signing in carries the current session.
const readSessionToken = () => {
  try {
    const raw = Cookies.get("userKeys");
    return raw ? JSON.parse(raw)?.userToken || null : null;
  } catch (e) {
    return null;
  }
};

const socketMiddleware = (store) => (next) => (action) => {
  // Handle socket connection
  if (action.type === "SOCKET_CONNECT") {
    if (!socketInstance) {
      socketInstance = io(BASE_URL, {
        auth: (cb) => cb({ token: readSessionToken() }),
      });

      socketInstance.on("connect_error", (error) => {
        // A rejected handshake means the session is missing or no longer
        // valid; the HTTP interceptor handles signing out.
        console.warn("Live updates unavailable:", error?.message);
      });

      // Handle socket events inside the connection block
      socketInstance.on("update-read-notification", (notification) => {
        store.dispatch(updateReadNotification(notification));
      });

      socketInstance.on("receive-notification", (notification) => {
        store.dispatch(addNewNotification(notification));
      });
      socketInstance.on("received-updated-events", (data) => {
        console.log("received-updated-events and dispatching", data);
        // Dispatch action to trigger events refresh
        store.dispatch(triggerEventsRefresh());
      });
    } else {
      console.log("Socket already connected");
    }
  }

  // Handle socket disconnection
  if (action.type === "SOCKET_DISCONNECT") { 
    if (socketInstance) {
      socketInstance.disconnect();
      socketInstance = null; // Reset the socket instance
    }
  }

  // Handle socket event emission
  if (action.type === "SOCKET_EMIT_EVENT") {
    const { event, data } = action.payload;
    if (socketInstance) {
      socketInstance.emit(event, data);
    } else {
      console.log("Socket not connected, cannot emit event");
    }
  }

  return next(action);
};

export default socketMiddleware;
